import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { theme } from '../theme';
import { hasSideNavigationBar } from '../utils/has-side-navigation-bar';
import { SideNavActionStrip } from './SideNavActionStrip';
import { DefaultActionStrip } from './DefaultActionStrip';
var defaultProps = {
  disableResponsiveSticky: false,
  maxWidth: 1200,
  preventDefault: false,
  showBack: true,
  showInverted: false,
  showResponsiveTitle: true,
  hasStickySettings: false,
  stripColor: theme.colors.white,
  invertedStripColor: theme.colors.green,
  invertedStripTransitionColor: theme.colors.white,
  showTitleOnLoad: false,
  showSubtextOnLoad: false,
  showChildrenIconsOnLoad: false,
  titleColorOnLoad: theme.colors.slate,
  subtextColorOnLoad: theme.colors.slate,
  stickyScroll: true,
  actionBackgroundColor: theme.colors.ivory,
  actionFadeColor: theme.colors.ivoryLight,
  minWidthToShowButtonText: 600,
  withSideBarNav: false,
  leftActions: []
};

var ActionStrip = function ActionStrip(props) {
  var isSBNavEnabled = hasSideNavigationBar();
  props = _objectSpread(_objectSpread({}, defaultProps), props);

  if (isSBNavEnabled) {
    return /*#__PURE__*/React.createElement(SideNavActionStrip, props);
  } else {
    return /*#__PURE__*/React.createElement(DefaultActionStrip, props);
  }
};

export default ActionStrip;